<template>
  <div class="checkout-page">
    <nav class="ck-nav"><div class="container d-flex align-items-center py-2"><a href="javascript:void(0)" @click="$router.go(-1)" class="ck-back"><i class="mdi mdi-arrow-left"></i></a><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" class="me-3" /><h6 class="mb-0" style="color:var(--fm-h,#F5F0E8);font-weight:600;">Secure Checkout</h6><div class="ms-auto d-flex align-items-center gap-2"><i class="mdi mdi-shield-check" style="color:#50C878;font-size:18px;"></i><span style="color:#50C878;font-size:12px;font-weight:500;">Escrow Protected</span></div></div></nav>
    <div v-if="loading" class="text-center py-5 mt-5"><div class="spinner-border text-warning"></div><p style="color:var(--fm-m,#A09888);" class="mt-3">Loading order details...</p></div>
    <div v-else-if="loadError" class="text-center py-5 mt-5"><i class="mdi mdi-alert-circle-outline" style="font-size:48px;color:#FF6B6B;"></i><p style="color:var(--fm-m,#A09888);" class="mt-3">{{ loadError }}</p><button class="btn btn-outline-warning btn-sm" @click="$router.go(-1)">Go Back</button></div>

    <!-- ORDER SUCCESS -->
    <div v-else-if="orderSuccess" class="container mt-5 pt-5">
      <div class="ck-card text-center py-4"><div class="ck-success-icon mb-3"><i class="mdi mdi-check-bold"></i></div><h4 style="color:var(--fm-h,#F5F0E8);font-weight:700;">Order Placed Successfully!</h4><p style="color:var(--fm-m,#A09888);" class="mb-1">Order Number: <strong style="color:#BFA164;">{{ createdOrder.orderNumber }}</strong></p><p style="color:var(--fm-m,#A09888);">Total: <strong style="color:#50C878;">KES {{ formatPrice(createdOrder.totalAmount) }}</strong></p></div>
      <div class="ck-card mt-3">
        <div v-if="paymentStatus === 'stk_sent'" class="text-center">
          <div class="ck-mpesa-prompt mb-3"><div class="d-flex align-items-center justify-content-center gap-2 mb-2"><div class="ck-pulse"></div><span style="color:#50C878;font-weight:600;">Waiting for M-Pesa PIN</span></div><p style="color:var(--fm-m,#A09888);font-size:13px;margin:0;">Check your phone <strong style="color:var(--fm-h,#F5F0E8);">{{ paymentPhone }}</strong> and enter your M-Pesa PIN.</p></div>
          <div style="color:var(--fm-s,#6B6356);font-size:12px;" class="mb-3"><i class="mdi mdi-refresh mdi-spin me-1"></i>Checking payment status... ({{ pollCountdown }}s)</div>
        </div>
        <div v-else-if="paymentStatus === 'completed'" class="text-center">
          <div style="padding:20px;background:rgba(80,200,120,0.08);border:1px solid rgba(80,200,120,0.2);border-radius:12px;"><i class="mdi mdi-check-circle" style="font-size:48px;color:#50C878;"></i><h5 style="color:#50C878;font-weight:700;margin-top:10px;">Payment Confirmed!</h5><p v-if="mpesaReceipt" style="color:var(--fm-m,#A09888);font-size:13px;margin:0;">M-Pesa Receipt: <strong style="color:var(--fm-h,#F5F0E8);">{{ mpesaReceipt }}</strong></p><p style="color:var(--fm-m,#A09888);font-size:13px;margin-top:4px;">Your payment is held safely in escrow.</p></div>
        </div>
        <div v-else-if="paymentStatus === 'failed' || paymentStatus === 'cancelled'" class="text-center">
          <div style="padding:20px;background:rgba(255,107,107,0.06);border:1px solid rgba(255,107,107,0.15);border-radius:12px;" class="mb-3"><i class="mdi mdi-close-circle" style="font-size:40px;color:#FF6B6B;"></i><h5 style="color:#FF6B6B;font-weight:700;margin-top:10px;">{{ paymentStatus === 'cancelled' ? 'Payment Cancelled' : 'Payment Failed' }}</h5><p style="color:var(--fm-m,#A09888);font-size:13px;margin:0;">{{ paymentFailReason || 'Payment could not be processed.' }}</p></div>
          <div class="mb-3"><h6 style="color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:600;margin-bottom:10px;"><i class="mdi mdi-refresh me-1"></i>Try Again</h6><div class="d-flex gap-2 align-items-center justify-content-center mb-2"><span style="color:var(--fm-s,#6B6356);font-size:14px;font-weight:500;">+254</span><input v-model="retryPhone" type="tel" class="ck-input" placeholder="7XX XXX XXX" style="max-width:200px;" maxlength="10" /></div><button class="btn btn-warning text-dark fw-bold" @click="retryStkPush" :disabled="retryingStk"><span v-if="retryingStk"><span class="spinner-border spinner-border-sm me-1"></span>Sending...</span><span v-else><i class="mdi mdi-cellphone me-1"></i>Resend M-Pesa Prompt</span></button></div>
        </div>
        <div v-else-if="paymentStatus === 'initiated'" class="text-center"><div class="ck-mpesa-prompt"><div class="d-flex align-items-center justify-content-center gap-2 mb-2"><div class="ck-pulse"></div><span style="color:#BFA164;font-weight:600;">Payment Processing</span></div><p style="color:var(--fm-m,#A09888);font-size:13px;margin:0;">Your payment is being processed...</p></div></div>
        <div v-if="paymentStatus !== 'completed'" class="mt-4" style="border-top:1px solid #1E1E1E;padding-top:16px;"><h6 style="color:var(--fm-m,#A09888);font-size:13px;font-weight:600;margin-bottom:12px;"><i class="mdi mdi-bank me-1"></i>Or Pay Manually via M-Pesa Paybill</h6><div class="ck-paybill-grid"><div><span class="ck-label">Paybill Number</span><span class="ck-value" style="color:#BFA164;">4160303</span></div><div><span class="ck-label">Account Number</span><span class="ck-value">{{ createdOrder.orderNumber }}</span></div><div><span class="ck-label">Amount</span><span class="ck-value" style="color:#50C878;">KES {{ formatPrice(createdOrder.totalAmount) }}</span></div></div><p style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:8px;"><i class="mdi mdi-information-outline me-1"></i>M-Pesa &gt; Lipa na M-Pesa &gt; Pay Bill &gt; Enter details above</p></div>
      </div>
      <div class="d-flex justify-content-center gap-3 mt-4"><button class="btn btn-outline-warning" @click="$router.push('/orders/' + createdOrder.orderId)"><i class="mdi mdi-receipt me-1"></i>View Order</button><button class="btn btn-outline-secondary" @click="$router.push('/marketplace')"><i class="mdi mdi-storefront me-1"></i>Marketplace</button></div>
    </div>

    <!-- CHECKOUT FORM -->
    <div v-else class="container mt-5 pt-4"><div class="row g-4"><div class="col-lg-7">
      <div class="ck-steps mb-4"><div class="ck-step" :class="{ active: step >= 1, done: step > 1 }" @click="step > 1 ? step = 1 : null"><div class="ck-step-num">{{ step > 1 ? '✓' : '1' }}</div><span>Delivery</span></div><div class="ck-step-line" :class="{ active: step >= 2 }"></div><div class="ck-step" :class="{ active: step >= 2, done: step > 2 }" @click="step > 2 ? step = 2 : null"><div class="ck-step-num">{{ step > 2 ? '✓' : '2' }}</div><span>Payment</span></div><div class="ck-step-line" :class="{ active: step >= 3 }"></div><div class="ck-step" :class="{ active: step >= 3 }"><div class="ck-step-num">3</div><span>Confirm</span></div></div>

      <!-- ===== STEP 1: DELIVERY ===== -->
      <div v-if="step === 1" class="ck-card">
        <h5 class="ck-card-title"><i class="mdi mdi-truck-delivery me-2"></i>Delivery Option</h5>
        <div class="ck-delivery-options">

          <!-- BUYER COLLECTS -->
          <label class="ck-option" :class="{ selected: form.transportOption === 'buyer_collects' }" @click="selectDelivery('buyer_collects', 0)">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'buyer_collects'"></div></div>
            <div><div class="ck-option-title"><i class="mdi mdi-walk me-1"></i>I will Collect</div><div class="ck-option-desc">Pick up from seller location. No transport fee.</div><div class="ck-option-price" style="color:#50C878;">Free</div></div>
          </label>

          <!-- SELLER DELIVERS (has per-KM pricing, within range) -->
          <label v-if="sellerHasDelivery && !sellerExceedsMaxKm" class="ck-option" :class="{ selected: form.transportOption === 'seller_delivers' }" @click="selectDelivery('seller_delivers', sellerDeliveryFee)">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'seller_delivers'"></div></div>
            <div>
              <div class="ck-option-title"><i class="mdi mdi-truck me-1"></i>Seller Delivers</div>
              <div class="ck-option-desc">
                Base: KES {{ formatPrice(listing.delivery_base_fee || 0) }} + KES {{ formatPrice(listing.delivery_per_km || 0) }}/km
                <span v-if="deliveryDistanceKm > 0" style="color:#50C878;"> · {{ deliveryDistanceKm }}km away</span>
                <span v-if="listing.delivery_notes"><br/>{{ listing.delivery_notes }}</span>
              </div>
              <div class="ck-option-price">KES {{ formatPrice(sellerDeliveryFee) }}<span v-if="deliveryDistanceKm === 0" style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:400;"> (pick location for exact price)</span></div>
            </div>
          </label>

          <!-- SELLER DELIVERS (exceeds max distance) -->
          <label v-if="sellerHasDelivery && sellerExceedsMaxKm" class="ck-option" :class="{ selected: form.transportOption === 'seller_negotiate' }" @click="form.transportOption = 'seller_negotiate'; form.transportFee = 0" style="opacity:0.7;">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'seller_negotiate'"></div></div>
            <div>
              <div class="ck-option-title"><i class="mdi mdi-truck-alert me-1" style="color:#FF8C00;"></i>Seller Delivers (Too Far)</div>
              <div class="ck-option-desc">Seller only delivers up to {{ listing.delivery_max_km }}km. You're {{ deliveryDistanceKm }}km away. Chat to negotiate.</div>
              <div style="margin-top:8px;"><button class="btn btn-sm btn-outline-warning" @click.stop="chatWithSeller"><i class="mdi mdi-message-text me-1"></i>Chat with Seller</button></div>
            </div>
          </label>

          <!-- NO DELIVERY SET AT ALL — negotiate -->
          <label v-if="!sellerHasDelivery" class="ck-option" :class="{ selected: form.transportOption === 'seller_negotiate' }" @click="form.transportOption = 'seller_negotiate'; form.transportFee = 0">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'seller_negotiate'"></div></div>
            <div><div class="ck-option-title"><i class="mdi mdi-handshake me-1"></i>Seller Delivers (Negotiate)</div><div class="ck-option-desc">Seller hasn't set delivery fees. Chat to agree on price first.</div>
              <div style="margin-top:8px;"><button class="btn btn-sm btn-outline-warning" @click.stop="chatWithSeller"><i class="mdi mdi-message-text me-1"></i>Chat with Seller to Agree</button></div>
            </div>
          </label>

          <!-- FLOCKR TRANSPORT -->
          <label class="ck-option" :class="{ selected: form.transportOption === 'third_party' }" @click="selectFlockrTransport()">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'third_party'"></div></div>
            <div><div class="ck-option-title"><i class="mdi mdi-truck-fast me-1" style="color:#BFA164;"></i>Flockr Transport</div><div class="ck-option-desc">Professional livestock transport. Vehicle matched to your order.</div><div class="ck-option-price">From KES {{ formatPrice(cheapestVehicleFee) }}</div></div>
          </label>

          <!-- FLOCKR ARRANGES (admin-coordinated, paid separately) -->
          <label class="ck-option" :class="{ selected: form.transportOption === 'flockr_arranges' }" @click="selectAdminArrangedTransport()">
            <div class="ck-option-radio"><div class="ck-radio-dot" v-if="form.transportOption === 'flockr_arranges'"></div></div>
            <div>
              <div class="ck-option-title"><i class="mdi mdi-account-tie me-1" style="color:#BFA164;"></i>Flockr arranges for me</div>
              <div class="ck-option-desc">Pay just for the animals now — our team contacts you within 24 hours to organise transport with a verified transporter.</div>
              <div class="ck-option-price" style="color:#FF9800;">Transport invoiced separately</div>
            </div>
          </label>
        </div>

        <!-- ADMIN-ARRANGED INFO PANEL -->
        <div v-if="form.transportOption === 'flockr_arranges'" class="mt-4" style="padding:16px;border:1px solid rgba(191,161,100,.3);border-left:3px solid #BFA164;border-radius:8px;background:rgba(191,161,100,.05);">
          <div style="display:flex;gap:12px;align-items:flex-start;">
            <i class="mdi mdi-information-outline" style="font-size:22px;color:#BFA164;flex-shrink:0;margin-top:2px;"></i>
            <div style="flex:1;font-size:13px;color:var(--fm-m,#A09888);line-height:1.6;">
              <div style="color:var(--fm-h,#F5F0E8);font-weight:600;margin-bottom:6px;">How this works</div>
              <ol style="margin:0;padding-left:18px;">
                <li><strong style="color:var(--fm-h,#F5F0E8);">You pay for the animals now</strong> — secured in escrow as usual. Transport is <em>not</em> charged on this order.</li>
                <li>A Flockr coordinator contacts you within <strong>24 hours</strong> on the phone you registered with.</li>
                <li>We match you with a verified transporter, agree pickup + delivery + price with all parties.</li>
                <li>Transport is invoiced separately when the trip is confirmed. You can pay via M-Pesa.</li>
                <li>You'll be able to track the trip live via your <strong style="color:var(--fm-h,#F5F0E8);">My Transport Bookings</strong> page once it's set up.</li>
              </ol>
              <div style="margin-top:10px;padding-top:10px;border-top:1px solid rgba(191,161,100,.2);">
                <strong style="color:#FF9800;">Note:</strong> please still pin a delivery location below — we use it to find the closest transporters and quote accurately.
              </div>
            </div>
          </div>
        </div>

        <!-- VEHICLE SELECTION (Flockr Transport) -->
        <div v-if="form.transportOption === 'third_party'" class="mt-4" style="padding-top:16px;border-top:1px solid var(--fm-br);">
          <label class="ck-label"><i class="mdi mdi-car-side me-1" style="color:#BFA164;"></i> Select Vehicle Type</label>
          <div class="ck-vehicle-grid">
            <div v-for="v in vehicleOptions" :key="v.id" class="ck-vehicle" :class="{ selected: form.vehicleType === v.id, unsuitable: !v.suitable }" @click="v.suitable ? selectVehicle(v) : null">
              <i :class="v.icon" class="ck-vehicle-icon" :style="{ color: form.vehicleType === v.id ? '#BFA164' : v.suitable ? '#A09888' : 'var(--fm-s,#3A3530)' }"></i>
              <div class="ck-vehicle-name">{{ v.name }}</div>
              <div class="ck-vehicle-cap">{{ v.capacity }}</div>
              <div v-if="v.suitable" class="ck-vehicle-fee">KES {{ formatPrice(v.fee) }}</div>
              <div v-else class="ck-vehicle-fee" style="color:#FF6B6B;font-size:9px;">Too small</div>
            </div>
          </div>
          <div v-if="selectedVehicle" class="ck-vehicle-info mt-3">
            <i class="mdi mdi-information me-1" style="color:#BFA164;flex-shrink:0;margin-top:1px;"></i>
            <span>{{ selectedVehicle.description }}</span>
          </div>
        </div>

        <!-- DELIVERY LOCATION (searchable) -->
        <div v-if="needsLocation" class="mt-4" style="position:relative;">
          <label class="ck-label"><i class="mdi mdi-map-marker me-1" style="color:#BFA164;"></i> Delivery Location</label>

          <!-- SEARCH + GPS ROW -->
          <div style="display:flex;gap:8px;">
            <div style="flex:1;position:relative;">
              <input v-model="form.deliveryLocation" type="text" class="ck-input" placeholder="Search town, market, area..." @input="onLocInput" @focus="showLocResults = true" autocomplete="off" style="padding-right:36px;" />
              <i v-if="locSearching" class="mdi mdi-loading mdi-spin" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);color:var(--fm-s,#6B6356);"></i>
              <i v-else-if="form.deliveryCoords" class="mdi mdi-check-circle" style="position:absolute;right:12px;top:50%;transform:translateY(-50%);color:#50C878;"></i>
            </div>
            <button class="btn ck-gps-btn" @click="useMyLocation" :disabled="geoLoading" title="Use my current location">
              <i v-if="geoLoading" class="mdi mdi-loading mdi-spin"></i>
              <i v-else class="mdi mdi-crosshairs-gps"></i>
            </button>
          </div>

          <!-- SEARCH DROPDOWN -->
          <div v-if="showLocResults && locResults.length > 0" class="ck-loc-dropdown">
            <div v-for="(loc, li) in locResults" :key="li" class="ck-loc-item" @click="pickLocation(loc)">
              <i class="mdi mdi-map-marker" style="color:#BFA164;flex-shrink:0;margin-top:2px;"></i>
              <div><div style="font-size:13px;color:var(--fm-h,#F5F0E8);">{{ loc.display_name }}</div><div style="font-size:11px;color:var(--fm-s,#6B6356);">{{ loc.area }}</div></div>
            </div>
          </div>

          <!-- INTERACTIVE MAP -->
          <div class="ck-map-container mt-3">
            <div id="deliveryMap" class="ck-interactive-map"></div>
            <div class="ck-map-hint"><i class="mdi mdi-gesture-tap me-1"></i>Tap the map to drop a pin</div>
          </div>

          <!-- LOCATION CONFIRMED -->
          <div v-if="form.deliveryCoords" class="ck-loc-confirmed mt-2">
            <i class="mdi mdi-check-circle me-1" style="color:#50C878;"></i>
            <span>{{ form.deliveryLocation || 'Pin dropped' }}</span>
            <span style="color:var(--fm-s,#6B6356);margin-left:4px;">({{ Number(form.deliveryCoords.lat).toFixed(4) }}, {{ Number(form.deliveryCoords.lon).toFixed(4) }})</span>
          </div>

          <!-- DISTANCE BADGE -->
          <div v-if="deliveryDistanceKm > 0" class="ck-distance-badge mt-2">
            <i class="mdi mdi-map-marker-distance me-1"></i>
            <span><strong>{{ deliveryDistanceKm }}km</strong> from animal to delivery</span>
            <span v-if="form.transportOption === 'seller_delivers'" style="color:#BFA164;margin-left:8px;">· KES {{ formatPrice(sellerDeliveryFee) }}</span>
          </div>
        </div>

        <div class="mt-4"><label class="ck-label">Notes to Seller (optional)</label><textarea v-model="form.buyerNotes" class="ck-input" rows="2" placeholder="Any special instructions..."></textarea></div>

        <!-- INSURANCE -->
        <div class="ck-insurance mt-4"><div class="d-flex align-items-center justify-content-between"><div><div style="color:var(--fm-h,#F5F0E8);font-size:14px;font-weight:600;"><i class="mdi mdi-shield-check me-1" style="color:#50C878;"></i>Livestock Transit Insurance</div><div style="color:var(--fm-m,#A09888);font-size:12px;">Covers death, injury, or loss during transport. 2% of animal value.</div></div><div class="form-check form-switch"><input class="form-check-input" type="checkbox" v-model="includeInsurance" /></div></div><div v-if="includeInsurance" style="color:#50C878;font-size:13px;font-weight:600;" class="mt-2">+ KES {{ formatPrice(insuranceFee) }}</div></div>

        <button class="btn btn-warning text-dark fw-bold w-100 mt-4" :disabled="!canProceedStep1" @click="step = 2">Continue to Payment <i class="mdi mdi-arrow-right ms-1"></i></button>
        <div v-if="form.transportOption === 'seller_negotiate'" class="text-center mt-2" style="font-size:12px;color:#FFAB00;"><i class="mdi mdi-alert me-1"></i>Chat with the seller to agree on delivery fee before proceeding</div>
      </div>

      <!-- ===== STEP 2: PAYMENT ===== -->
      <div v-if="step === 2" class="ck-card"><h5 class="ck-card-title"><i class="mdi mdi-credit-card me-2"></i>Payment Method</h5><div class="ck-delivery-options">
        <label class="ck-option" :class="{ selected: paymentMethod === 'mpesa_stk' }" @click="paymentMethod = 'mpesa_stk'"><div class="ck-option-radio"><div class="ck-radio-dot" v-if="paymentMethod === 'mpesa_stk'"></div></div><div><div class="ck-option-title"><i class="mdi mdi-cellphone me-1" style="color:#50C878;"></i>M-Pesa STK Push</div><div class="ck-option-desc">Receive a prompt on your phone. Enter PIN to pay.</div></div></label>
        <label class="ck-option" :class="{ selected: paymentMethod === 'mpesa_c2b' }" @click="paymentMethod = 'mpesa_c2b'"><div class="ck-option-radio"><div class="ck-radio-dot" v-if="paymentMethod === 'mpesa_c2b'"></div></div><div><div class="ck-option-title"><i class="mdi mdi-bank me-1" style="color:#BFA164;"></i>M-Pesa Paybill</div><div class="ck-option-desc">Send payment manually via Paybill 4160303.</div></div></label>
      </div>
        <div v-if="paymentMethod === 'mpesa_stk'" class="mt-4"><label class="ck-label">M-Pesa Phone Number</label><div class="ck-phone-input"><span class="ck-phone-prefix">+254</span><input v-model="paymentPhone" type="tel" class="ck-input" placeholder="7XX XXX XXX" style="padding-left:60px;" maxlength="10" /></div></div>
        <div v-if="paymentMethod === 'mpesa_c2b'" class="ck-paybill-info mt-4"><p style="color:var(--fm-m,#A09888);font-size:13px;">After placing the order, send payment using:</p><div class="ck-paybill-grid"><div><span class="ck-label">Paybill Number</span><span class="ck-value">4160303</span></div><div><span class="ck-label">Account Number</span><span class="ck-value">(Will be your Order #)</span></div><div><span class="ck-label">Amount</span><span class="ck-value">KES {{ formatPrice(totalAmount) }}</span></div></div></div>
        <div class="d-flex gap-3 mt-4"><button class="btn btn-outline-secondary" @click="step = 1"><i class="mdi mdi-arrow-left me-1"></i>Back</button><button class="btn btn-warning text-dark fw-bold flex-fill" @click="step = 3">Review Order <i class="mdi mdi-arrow-right ms-1"></i></button></div></div>

      <!-- ===== STEP 3: REVIEW ===== -->
      <div v-if="step === 3" class="ck-card"><h5 class="ck-card-title"><i class="mdi mdi-check-circle-outline me-2"></i>Review and Confirm</h5>
        <div class="ck-review-section"><div class="ck-review-label">Delivery</div><div class="ck-review-value"><span v-if="form.transportOption === 'buyer_collects'">Buyer Collects (Free)</span><span v-else-if="form.transportOption === 'seller_delivers'">Seller Delivers — KES {{ formatPrice(form.transportFee) }}</span><span v-else>Flockr Transport ({{ form.vehicleLabel || 'Standard' }}) — KES {{ formatPrice(form.transportFee) }}</span></div><div v-if="form.deliveryLocation" class="ck-review-sub"><i class="mdi mdi-map-marker me-1"></i>{{ form.deliveryLocation }}</div></div>
        <div class="ck-review-section"><div class="ck-review-label">Payment</div><div class="ck-review-value"><span v-if="paymentMethod === 'mpesa_stk'"><i class="mdi mdi-cellphone me-1"></i>M-Pesa STK to {{ paymentPhone }}</span><span v-else><i class="mdi mdi-bank me-1"></i>M-Pesa Paybill</span></div></div>
        <div v-if="includeInsurance" class="ck-review-section"><div class="ck-review-label">Insurance</div><div class="ck-review-value" style="color:#50C878;"><i class="mdi mdi-shield-check me-1"></i>Transit Insurance — KES {{ formatPrice(insuranceFee) }}</div></div>
        <div v-if="form.buyerNotes" class="ck-review-section"><div class="ck-review-label">Notes</div><div class="ck-review-value">{{ form.buyerNotes }}</div></div>
        <div class="ck-escrow-info mt-3"><div class="d-flex align-items-center gap-2 mb-2"><i class="mdi mdi-shield-lock" style="color:#50C878;font-size:20px;"></i><strong style="color:var(--fm-h,#F5F0E8);font-size:14px;">Escrow Protection</strong></div><p style="color:var(--fm-m,#A09888);font-size:12px;margin:0;">Your payment is held in escrow until you confirm delivery. Raise a dispute for a full refund if needed.</p></div>
        <div style="text-align:center;margin-top:14px;"><p style="color:#4A4540;font-size:11px;line-height:1.5;margin:0;">By placing this order, you agree to Flockr's <a href="javascript:void(0)" style="color:#BFA164;text-decoration:underline;">Terms &amp; Conditions</a>.</p></div>
        <div v-if="submitError" class="alert alert-danger mt-3" style="font-size:13px;">{{ submitError }}</div>
        <div class="d-flex gap-3 mt-4"><button class="btn btn-outline-secondary" @click="step = 2"><i class="mdi mdi-arrow-left me-1"></i>Back</button><button class="btn btn-warning text-dark fw-bold flex-fill" @click="placeOrder" :disabled="submitting"><span v-if="submitting"><span class="spinner-border spinner-border-sm me-1"></span>Processing...</span><span v-else><i class="mdi mdi-lock me-1"></i>Pay KES {{ formatPrice(totalAmount) }}</span></button></div>
      </div>
    </div>

      <!-- ORDER SUMMARY SIDEBAR -->
      <div class="col-lg-5"><div class="ck-card ck-sticky"><h6 class="ck-card-title"><i class="mdi mdi-receipt me-2"></i>Order Summary</h6>
        <div class="ck-listing-card"><img :src="photoUrl(listing.primary_photo)" :alt="listing.title" class="ck-listing-img" v-if="listing.primary_photo" /><div class="ck-listing-placeholder" v-else><i class="mdi mdi-cow" style="font-size:28px;color:var(--fm-s,#6B6356);"></i></div><div><div class="ck-listing-title">{{ listing.title }}</div><div class="ck-listing-meta">{{ listing.species_name }} <span v-if="listing.breed_name">- {{ listing.breed_name }}</span></div><div class="ck-listing-meta"><i class="mdi mdi-map-marker"></i> {{ listing.county_name || listing.location_description }}</div><div v-if="listing.weight_kg" class="ck-listing-meta"><i class="mdi mdi-weight-kilogram"></i> {{ listing.weight_kg }}kg</div></div></div>

        <!-- ANIMAL LOCATION MAP -->
        <div v-if="listing.latitude && listing.longitude" class="mt-3">
          <div style="font-size:11px;color:var(--fm-s,#6B6356);margin-bottom:4px;"><i class="mdi mdi-map-marker me-1" style="color:#BFA164;"></i>Animal Location</div>
          <div class="ck-mini-map"><iframe :src="animalMapUrl" style="width:100%;height:100%;border:none;border-radius:8px;" allowfullscreen></iframe></div>
        </div>
        <div class="d-flex align-items-center gap-2 mt-3 mb-3" style="padding:10px;background:var(--fm-bg2,#0F0F0F);border-radius:8px;"><div class="ck-seller-avatar">{{ sellerInitials }}</div><div><div style="color:var(--fm-h,#F5F0E8);font-size:13px;font-weight:600;">{{ offer.seller_name || 'Seller' }}</div><div style="color:var(--fm-s,#6B6356);font-size:11px;">Verified Seller</div></div></div>
        <div class="ck-price-breakdown"><div class="ck-price-row"><span>Agreed Price ({{ offer.quantity || 1 }}x)</span><span>KES {{ formatPrice(subtotal) }}</span></div><div class="ck-price-row"><span>Platform Fee (3%)</span><span>KES {{ formatPrice(platformFee) }}</span></div><div class="ck-price-row" v-if="form.transportFee > 0"><span>Transport <span v-if="form.vehicleLabel" style="color:var(--fm-s,#6B6356);font-size:11px;">({{ form.vehicleLabel }})</span></span><span>KES {{ formatPrice(form.transportFee) }}</span></div><div class="ck-price-row" v-if="includeInsurance"><span>Transit Insurance</span><span style="color:#50C878;">KES {{ formatPrice(insuranceFee) }}</span></div><div class="ck-price-total"><span>Total</span><span>KES {{ formatPrice(totalAmount) }}</span></div></div>
        <div class="ck-trust-badges mt-3"><div class="ck-badge"><i class="mdi mdi-shield-check"></i> Escrow</div><div class="ck-badge"><i class="mdi mdi-undo"></i> Refund</div><div class="ck-badge"><i class="mdi mdi-lock"></i> Secure</div></div>
      </div></div></div></div>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, flocker, uploads } from "@/api";
export default {
  name: "CheckoutPage",
  data() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
      themeObserver: null,

      loading: true, loadError: "", step: 1, listing: {}, offer: {},
      form: {
        transportOption: "buyer_collects", transportFee: 0,
        deliveryLocation: "", deliveryCoords: null,
        buyerNotes: "", vehicleType: "", vehicleLabel: ""
      },
      paymentMethod: "mpesa_stk", paymentPhone: "", includeInsurance: false,
      submitting: false, submitError: "", orderSuccess: false, paymentInitiated: false, createdOrder: {},
      paymentStatus: "", paymentRef: "", checkoutRequestId: "", mpesaReceipt: "", paymentFailReason: "",
      pollTimer: null, pollCountdown: 5, retryPhone: "", retryingStk: false,
      showLocResults: false, locResults: [], locSearching: false, locTimer: null,
      geoLoading: false, mapInstance: null, deliveryMarker: null, animalMarker: null, routeLine: null,
    };
  },
  computed: {
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    subtotal() { var p = parseFloat(this.offer.offered_price || this.offer.counter_price || this.listing.price || 0); return p * parseInt(this.offer.quantity || 1); },
    platformFee() { return Math.round(this.subtotal * 0.03); },
    insuranceFee() { return this.includeInsurance ? Math.round(this.subtotal * 0.02) : 0; },
    totalAmount() { return this.subtotal + this.platformFee + this.form.transportFee + this.insuranceFee; },
    sellerInitials() { var n = this.offer.seller_name || ""; return n.split(" ").map(function(p){return p.charAt(0);}).join("").substring(0,2).toUpperCase(); },
    animalMapUrl() {
      if (!this.listing.latitude || !this.listing.longitude) return '';
      var lat = Number(this.listing.latitude); var lon = Number(this.listing.longitude);
      return 'https://www.openstreetmap.org/export/embed.html?bbox=' + (lon-0.02) + ',' + (lat-0.015) + ',' + (lon+0.02) + ',' + (lat+0.015) + '&layer=mapnik&marker=' + lat + ',' + lon;
    },

    sellerHasDelivery() {
      if (this.listing.offers_delivery != '1' && this.listing.offers_delivery != 1) return false;
      return Number(this.listing.delivery_base_fee || 0) > 0 || Number(this.listing.delivery_per_km || 0) > 0;
    },
    deliveryDistanceKm() {
      // Haversine formula between listing and delivery coords
      if (!this.form.deliveryCoords || !this.listing.latitude || !this.listing.longitude) return 0;
      var R = 6371;
      var lat1 = Number(this.listing.latitude) * Math.PI / 180;
      var lat2 = Number(this.form.deliveryCoords.lat) * Math.PI / 180;
      var dLat = (Number(this.form.deliveryCoords.lat) - Number(this.listing.latitude)) * Math.PI / 180;
      var dLon = (Number(this.form.deliveryCoords.lon) - Number(this.listing.longitude)) * Math.PI / 180;
      var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon/2) * Math.sin(dLon/2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return Math.round(R * c);
    },
    sellerDeliveryFee() {
      var base = Number(this.listing.delivery_base_fee || 0);
      var perKm = Number(this.listing.delivery_per_km || 0);
      var dist = this.deliveryDistanceKm;
      if (dist === 0) return base; // show base fee before location is picked
      return Math.round(base + (perKm * dist));
    },
    sellerExceedsMaxKm() {
      var maxKm = Number(this.listing.delivery_max_km || 0);
      if (maxKm === 0) return false; // 0 = unlimited
      return this.deliveryDistanceKm > maxKm;
    },
    needsLocation() {
      return this.form.transportOption !== 'buyer_collects' && this.form.transportOption !== 'seller_negotiate';
    },
    canProceedStep1() {
      if (this.form.transportOption === 'seller_negotiate') return false;
      if (this.needsLocation && !this.form.deliveryLocation.trim()) return false;
      if (this.form.transportOption === 'third_party' && !this.form.vehicleType) return false;
      return true;
    },

    // Dynamic vehicle options based on species, weight, quantity
    vehicleOptions() {
      var w = Number(this.listing.weight_kg || this.listing.avg_weight_kg || 0);
      var qty = parseInt(this.offer.quantity || 1);
      var totalW = w * qty;
      var base = this.subtotal;
      var species = (this.listing.species_name || '').toLowerCase();

      var isLarge = /cattle|cow|bull|camel|horse|donkey/.test(species);
      var isMedium = /goat|sheep|pig|calf/.test(species);
      // small: poultry, rabbits, etc.

      return [
        {
          id: 'pickup', name: 'Pickup', icon: 'mdi mdi-car-pickup',
          capacity: '1–3 small animals',
          description: 'Small pickup truck. Best for goats, sheep, rabbits, or poultry. Max load ~200kg.',
          suitable: !isLarge && totalW <= 200 && qty <= 6,
          fee: Math.max(500, Math.round(base * 0.04))
        },
        {
          id: 'pickup_caged', name: 'Caged Pickup', icon: 'mdi mdi-car-estate',
          capacity: '3–6 medium animals',
          description: 'Pickup with livestock cage. Safe for goats, sheep, young calves. Max load ~500kg.',
          suitable: totalW <= 500 && (!isLarge || qty <= 1),
          fee: Math.max(1500, Math.round(base * 0.06))
        },
        {
          id: 'canter', name: 'Canter', icon: 'mdi mdi-truck',
          capacity: '2–6 cattle or 10+ small',
          description: 'Medium truck (3–5 ton). Ideal for cattle, bulk goats/sheep. Partitioned for safety.',
          suitable: totalW <= 3000,
          fee: Math.max(3000, Math.round(base * 0.08))
        },
        {
          id: 'lorry', name: 'Lorry / Truck', icon: 'mdi mdi-truck-trailer',
          capacity: '6–15 cattle or 30+ small',
          description: 'Large truck (7–10 ton). For bulk livestock and long-distance transport. Full handling included.',
          suitable: true,
          fee: Math.max(5000, Math.round(base * 0.10))
        }
      ];
    },
    cheapestVehicleFee() {
      var suitable = this.vehicleOptions.filter(function(v) { return v.suitable; });
      if (!suitable.length) return this.vehicleOptions[this.vehicleOptions.length - 1].fee;
      return Math.min.apply(null, suitable.map(function(v) { return v.fee; }));
    },
    selectedVehicle() {
      var id = this.form.vehicleType;
      return this.vehicleOptions.find(function(v) { return v.id === id; }) || null;
    }
  },
  mounted() {
    this.syncTheme();
    this.themeObserver = new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    this.loadCheckoutData();
  },
  watch: {
    sellerDeliveryFee(newFee) {
      if (this.form.transportOption === 'seller_delivers') this.form.transportFee = newFee;
    },
    needsLocation(val) {
      if (val) { var self = this; this.$nextTick(function() { self.initMap(); }); }
    }
  },
  methods: {
    syncTheme() {
      var t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || 'dark';
      window.__flockrSetTheme(t);
      this.darkMode = t !== 'light';
      if (document.body) {
        document.body.setAttribute('data-sidebar', this.darkMode ? 'dark' : 'light');
        document.body.style.background = this.darkMode ? '#0A0A0A' : '#F7F5F2';
        document.body.style.color = this.darkMode ? '#F5F0E8' : '#1A1A1A';
      }
    },
    photoUrl(p) { if(!p) return ""; if(p.startsWith && p.startsWith("http")) return p; return uploads + String(p).replace("uploads/",""); },
    formatPrice(v) { return Number(v||0).toLocaleString(); },

    selectDelivery(option, fee) {
      this.form.transportOption = option;
      this.form.transportFee = fee;
      this.form.vehicleType = ""; this.form.vehicleLabel = "";
      if (option === "buyer_collects") { this.form.deliveryLocation = ""; this.form.deliveryCoords = null; }
    },
    selectFlockrTransport() {
      this.form.transportOption = 'third_party';
      var suitable = this.vehicleOptions.filter(function(v) { return v.suitable; });
      if (suitable.length) this.selectVehicle(suitable[0]);
      else this.selectVehicle(this.vehicleOptions[this.vehicleOptions.length - 1]);
    },
    selectAdminArrangedTransport() {
      // Flockr-arranged transport — buyer pays for goods only. Admin contacts them within 24h.
      this.form.transportOption = 'flockr_arranges';
      this.form.transportFee = 0;
      this.form.vehicleType = '';
      this.form.vehicleLabel = '';
    },
    selectVehicle(v) {
      this.form.vehicleType = v.id;
      this.form.vehicleLabel = v.name;
      this.form.transportFee = v.fee;
    },
    chatWithSeller() {
      var sellerId = this.offer.seller_id || this.listing.seller_id;
      if (sellerId) this.$router.push('/messages?to=' + sellerId + '&listing=' + (this.listing.id || ''));
    },

    // Location search via Nominatim (Kenya)
    onLocInput() {
      this.form.deliveryCoords = null;
      if (this.locTimer) clearTimeout(this.locTimer);
      var self = this;
      var q = (this.form.deliveryLocation || '').trim();
      if (q.length < 3) { this.locResults = []; this.showLocResults = false; return; }
      this.locTimer = setTimeout(function() { self.searchLocation(q); }, 400);
    },
    async searchLocation(q) {
      this.locSearching = true;
      try {
        var url = 'https://nominatim.openstreetmap.org/search?format=json&countrycodes=ke&limit=6&q=' + encodeURIComponent(q);
        var res = await fetch(url);
        var data = await res.json();
        this.locResults = data.map(function(d) {
          var parts = (d.display_name || '').split(',');
          return {
            name: parts[0] || d.display_name,
            display_name: parts.slice(0, 3).join(', ').trim(),
            area: parts.slice(1, 4).join(', ').trim(),
            lat: d.lat, lon: d.lon
          };
        });
        this.showLocResults = true;
      } catch (e) { this.locResults = []; }
      this.locSearching = false;
    },
    pickLocation(loc) {
      this.form.deliveryLocation = loc.display_name || loc.name;
      this.form.deliveryCoords = { lat: loc.lat, lon: loc.lon };
      this.showLocResults = false;
      if (this.form.transportOption === 'seller_delivers') {
        this.form.transportFee = this.sellerDeliveryFee;
      }
      this.updateMapPin(Number(loc.lat), Number(loc.lon));
    },

    // GPS: use current location
    useMyLocation() {
      if (!navigator.geolocation) return;
      this.geoLoading = true; var self = this;
      navigator.geolocation.getCurrentPosition(
          function(pos) {
            var lat = pos.coords.latitude; var lon = pos.coords.longitude;
            self.form.deliveryCoords = { lat: lat, lon: lon };
            self.geoLoading = false;
            self.updateMapPin(lat, lon);
            self.reverseGeocode(lat, lon);
          },
          function() { self.geoLoading = false; },
          { enableHighAccuracy: true, timeout: 10000 }
      );
    },

    // Reverse geocode coords to place name
    reverseGeocode(lat, lon) {
      var self = this;
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lon)
          .then(function(r) { return r.json(); })
          .then(function(d) {
            if (d && d.display_name) {
              var parts = d.display_name.split(',');
              self.form.deliveryLocation = parts.slice(0, 3).join(',').trim();
            }
          }).catch(function() {});
    },

    // Load Leaflet dynamically
    loadLeaflet(cb) {
      if (window.L) { cb(); return; }
      var css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      var js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload = cb;
      document.head.appendChild(js);
    },

    // Initialize or update the interactive map
    initMap() {
      var self = this;
      this.loadLeaflet(function() {
        self.$nextTick(function() {
          var el = document.getElementById('deliveryMap');
          if (!el) return;
          if (self.mapInstance) { self.mapInstance.invalidateSize(); return; }

          // Default center: listing location or Nairobi
          var centerLat = Number(self.listing.latitude) || -1.2921;
          var centerLon = Number(self.listing.longitude) || 36.8219;
          var zoom = self.listing.latitude ? 10 : 7;

          self.mapInstance = L.map('deliveryMap', { zoomControl: true, attributionControl: false }).setView([centerLat, centerLon], zoom);
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18 }).addTo(self.mapInstance);

          // Show animal location marker (green)
          if (self.listing.latitude && self.listing.longitude) {
            var animalIcon = L.divIcon({
              className: 'ck-animal-pin',
              html: '<div style="background:#50C878;width:14px;height:14px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,0.4);"></div>',
              iconSize: [14, 14], iconAnchor: [7, 7]
            });
            self.animalMarker = L.marker([Number(self.listing.latitude), Number(self.listing.longitude)], { icon: animalIcon })
                .addTo(self.mapInstance)
                .bindTooltip('Animal location', { permanent: false, direction: 'top' });
          }

          // Click to drop pin
          self.mapInstance.on('click', function(e) {
            self.form.deliveryCoords = { lat: e.latlng.lat, lon: e.latlng.lng };
            self.updateMapPin(e.latlng.lat, e.latlng.lng);
            self.reverseGeocode(e.latlng.lat, e.latlng.lng);
            if (self.form.transportOption === 'seller_delivers') {
              self.form.transportFee = self.sellerDeliveryFee;
            }
          });

          // If coords already set, show pin
          if (self.form.deliveryCoords) {
            self.updateMapPin(Number(self.form.deliveryCoords.lat), Number(self.form.deliveryCoords.lon));
          }
        });
      });
    },

    // Update/move the delivery pin on map + draw route line
    updateMapPin(lat, lon) {
      if (!this.mapInstance || !window.L) return;
      var deliveryIcon = L.divIcon({
        className: 'ck-delivery-pin',
        html: '<div style="background:#BFA164;width:16px;height:16px;border-radius:50%;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.5);"></div>',
        iconSize: [16, 16], iconAnchor: [8, 8]
      });
      if (this.deliveryMarker) {
        this.deliveryMarker.setLatLng([lat, lon]);
      } else {
        this.deliveryMarker = L.marker([lat, lon], { icon: deliveryIcon, draggable: true })
            .addTo(this.mapInstance)
            .bindTooltip('Delivery location', { permanent: false, direction: 'top' });
        var self = this;
        this.deliveryMarker.on('dragend', function(e) {
          var pos = e.target.getLatLng();
          self.form.deliveryCoords = { lat: pos.lat, lon: pos.lng };
          self.drawRoute();
          self.reverseGeocode(pos.lat, pos.lng);
          if (self.form.transportOption === 'seller_delivers') {
            self.form.transportFee = self.sellerDeliveryFee;
          }
        });
      }
      this.drawRoute();

      // Fit bounds to show both markers
      if (this.listing.latitude && this.listing.longitude) {
        var bounds = L.latLngBounds(
            [Number(this.listing.latitude), Number(this.listing.longitude)],
            [lat, lon]
        );
        this.mapInstance.fitBounds(bounds.pad(0.3));
      } else {
        this.mapInstance.setView([lat, lon], 14);
      }
    },

    // Draw dashed line between animal and delivery
    drawRoute() {
      if (!this.mapInstance || !window.L) return;
      if (this.routeLine) { this.mapInstance.removeLayer(this.routeLine); this.routeLine = null; }
      if (!this.listing.latitude || !this.listing.longitude || !this.form.deliveryCoords) return;
      this.routeLine = L.polyline([
        [Number(this.listing.latitude), Number(this.listing.longitude)],
        [Number(this.form.deliveryCoords.lat), Number(this.form.deliveryCoords.lon)]
      ], { color: '#BFA164', weight: 2, dashArray: '8, 6', opacity: 0.7 }).addTo(this.mapInstance);
    },

    // Load checkout data
    async loadCheckoutData() {
      this.loading = true; this.loadError = "";
      var offerId = this.$route.params.offerId;
      var listingId = this.$route.query.listingId;
      var isDirect = (offerId === "direct");
      var userId = sessionStorage.getItem("userId");
      if (!userId) { this.$router.push("/login"); return; }
      if (!offerId && !isDirect) { this.loadError = "No offer specified."; this.loading = false; return; }
      try {
        if (isDirect) {
          if (!listingId) { this.loadError = "No listing specified."; this.loading = false; return; }
          var lf = new FormData();
          lf.append("function","getListing"); lf.append("listingId",listingId);
          var lr = await execute(lf, flocker);
          if (lr.data && lr.data.data) this.listing = lr.data.data.listing || lr.data.data || {};
          if (!this.listing.id) { this.loadError = "Listing not found."; this.loading = false; return; }
          this.offer = { offered_price: this.listing.price, quantity: 1, seller_id: this.listing.seller_id, seller_name: this.listing.seller_name || this.listing.display_name || "Seller", listing_id: listingId, listing_title: this.listing.title, status: "accepted" };
          var ph = sessionStorage.getItem("userPhone") || "";
          if (ph) this.paymentPhone = ph;
          this.loading = false; return;
        }
        var offerForm = new FormData();
        offerForm.append("function","getListingOffers"); offerForm.append("buyerId",userId);
        var offRes = await execute(offerForm, flocker);
        var offers = (offRes.data && offRes.data.data && offRes.data.data.offers) || [];
        var found = offers.find(function(o) { return String(o.id) === String(offerId); });
        if (!found) { this.loadError = "Offer not found."; this.loading = false; return; }
        if (found.status !== "accepted") { this.loadError = "This offer has not been accepted yet. Status: " + found.status; this.loading = false; return; }
        this.offer = found;
        var phone = sessionStorage.getItem("userPhone") || "";
        if (phone) this.paymentPhone = phone;
        var lid = listingId || found.listing_id;
        if (lid) {
          var listForm = new FormData();
          listForm.append("function","getListing"); listForm.append("listingId",lid);
          var listRes = await execute(listForm, flocker);
          if (listRes.data && listRes.data.data) this.listing = listRes.data.data.listing || listRes.data.data || {};
        }
        this.loading = false;
      } catch(err) { this.loadError = "Failed to load checkout data."; this.loading = false; }
    },

    // Place order
    async placeOrder() {
      this.submitError = "";
      if (this.paymentMethod === "mpesa_stk" && !this.paymentPhone) { this.submitError = "Please enter your M-Pesa phone number."; return; }
      if (this.needsLocation && !this.form.deliveryLocation) { this.submitError = "Please enter a delivery location."; return; }
      this.submitting = true;
      var userId = sessionStorage.getItem("userId");
      try {
        var orderForm = new FormData();
        orderForm.append("function","createOrder");
        orderForm.append("buyerId", userId);
        orderForm.append("sellerId", this.offer.seller_id);
        orderForm.append("listingId", this.offer.listing_id || "");
        orderForm.append("quantity", this.offer.quantity || 1);
        orderForm.append("unitPrice", this.offer.offered_price || this.offer.counter_price || this.listing.price || 0);
        orderForm.append("transportOption", this.form.transportOption);
        orderForm.append("transportFee", this.form.transportFee);
        orderForm.append("insuranceFee", this.insuranceFee);
        orderForm.append("deliveryLocation", this.form.deliveryLocation);
        if (this.form.deliveryCoords) {
          orderForm.append("deliveryLatitude", this.form.deliveryCoords.lat);
          orderForm.append("deliveryLongitude", this.form.deliveryCoords.lon);
        }
        if (this.form.vehicleType) orderForm.append("vehicleType", this.form.vehicleType);
        orderForm.append("buyerNotes", this.form.buyerNotes);
        var orderRes = await execute(orderForm, flocker);
        if (!orderRes.data || !orderRes.data.success) { this.submitError = (orderRes.data && orderRes.data.message) || "Failed to create order."; this.submitting = false; return; }
        var orderData = orderRes.data.data;
        this.createdOrder = { orderId: orderData.orderId, orderNumber: orderData.orderNumber, totalAmount: orderData.totalAmount };
        if (this.paymentMethod === "mpesa_stk") {
          await this.sendStkPush(orderData.orderId, userId, this.paymentPhone, orderData.totalAmount);
        } else { this.paymentStatus = "awaiting_paybill"; }
        this.retryPhone = this.paymentPhone;
        this.orderSuccess = true; this.submitting = false;
      } catch(err) { this.submitError = "Something went wrong. Please try again."; this.submitting = false; }
    },
    async sendStkPush(orderId, userId, phone, amount) {
      var payForm = new FormData();
      payForm.append("function","initiatePayment"); payForm.append("orderId", orderId);
      payForm.append("userId", userId); payForm.append("paymentMethod","mpesa_stk");
      payForm.append("phone", phone); payForm.append("amount", amount);
      var payRes = await execute(payForm, flocker);
      if (payRes.data && payRes.data.success) {
        this.paymentInitiated = true; this.paymentStatus = "stk_sent";
        this.paymentRef = (payRes.data.data && payRes.data.data.paymentRef) || "";
        this.checkoutRequestId = (payRes.data.data && payRes.data.data.checkoutRequestId) || "";
        this.startPolling();
      } else { this.paymentStatus = "failed"; this.paymentFailReason = (payRes.data && payRes.data.message) || "STK push failed."; }
    },
    startPolling() { this.stopPolling(); this.pollCountdown = 5; var self = this; this.pollTimer = setInterval(function() { self.pollCountdown--; if (self.pollCountdown <= 0) { self.pollCountdown = 5; self.checkPayment(); } }, 1000); },
    stopPolling() { if (this.pollTimer) { clearInterval(this.pollTimer); this.pollTimer = null; } },
    async checkPayment() {
      if (!this.paymentRef && !this.checkoutRequestId) return;
      try {
        var form = new FormData(); form.append("function","checkPaymentStatus");
        if (this.paymentRef) form.append("paymentRef", this.paymentRef);
        if (this.checkoutRequestId) form.append("checkoutRequestId", this.checkoutRequestId);
        var res = await execute(form, flocker);
        if (res.data && res.data.success && res.data.data) {
          var st = res.data.data.status;
          if (st === "completed") { this.paymentStatus = "completed"; this.mpesaReceipt = res.data.data.mpesaReceipt || ""; this.stopPolling(); }
          else if (st === "failed") { this.paymentStatus = "failed"; this.paymentFailReason = res.data.data.failureReason || ""; this.stopPolling(); }
          else if (st === "cancelled") { this.paymentStatus = "cancelled"; this.paymentFailReason = res.data.data.failureReason || ""; this.stopPolling(); }
        }
      } catch(e) {}
    },
    async retryStkPush() {
      this.retryingStk = true; var phone = this.retryPhone || this.paymentPhone;
      if (!phone) { this.retryingStk = false; return; }
      var userId = sessionStorage.getItem("userId");
      this.paymentStatus = ""; this.paymentFailReason = "";
      await this.sendStkPush(this.createdOrder.orderId, userId, phone, this.createdOrder.totalAmount);
      this.retryingStk = false;
    }
  },
  beforeUnmount() { if (this.themeObserver) this.themeObserver.disconnect(); this.stopPolling(); if (this.locTimer) clearTimeout(this.locTimer); }
};
</script>

<style>
html[data-theme="light"] .checkout-page,
html[data-theme="light"] .ck-nav,
html[data-theme="light"] .container.mt-5.pt-4,
html[data-theme="light"] .container.mt-5.pt-5 {
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}
html[data-theme="light"] .ck-nav {
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .checkout-page,
html[data-theme="dark"] .ck-nav,
html[data-theme="dark"] .container.mt-5.pt-4,
html[data-theme="dark"] .container.mt-5.pt-5 {
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}
</style>

<style>
/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
.checkout-page { min-height:100vh; background:var(--fm-bg2,#0F0F0F); padding-bottom:60px; color:var(--fm-h,#F5F0E8); }
.ck-nav { background:var(--fm-bg2,#0F0F0F); border-bottom:1px solid var(--fm-br,#1E1E1E); position:fixed; top:0; left:0; right:0; z-index:100; }
.ck-back { color:var(--fm-m,#A09888); font-size:22px; margin-right:12px; text-decoration:none; }
.ck-back:hover { color:#BFA164; }
.ck-card { background:var(--fm-bg1,#141414); border:1px solid var(--fm-br,#1E1E1E); border-radius:12px; padding:24px; }
.ck-card-title { color:#BFA164; font-size:16px; font-weight:700; margin-bottom:20px; }
.ck-sticky { position:sticky; top:80px; }
.ck-steps { display:flex; align-items:center; justify-content:center; }
.ck-step { display:flex; flex-direction:column; align-items:center; gap:4px; cursor:pointer; }
.ck-step span { font-size:11px; color:var(--fm-s,#6B6356); font-weight:500; }
.ck-step.active span { color:#BFA164; }
.ck-step.done span { color:#50C878; }
.ck-step-num { width:32px; height:32px; border-radius:50%; border:2px solid #2A2520; display:flex; align-items:center; justify-content:center; color:var(--fm-s,#6B6356); font-size:13px; font-weight:700; }
.ck-step.active .ck-step-num { border-color:#BFA164; color:#BFA164; background:rgba(191,161,100,0.1); }
.ck-step.done .ck-step-num { border-color:#50C878; color:#50C878; background:rgba(80,200,120,0.1); }
.ck-step-line { width:60px; height:2px; background:#2A2520; margin:0 8px; margin-bottom:18px; }
.ck-step-line.active { background:#BFA164; }
.ck-delivery-options { display:flex; flex-direction:column; gap:12px; }
.ck-option { display:flex; gap:14px; padding:16px; background:var(--fm-bg2,#0F0F0F); border:1px solid var(--fm-br,#1E1E1E); border-radius:10px; cursor:pointer; transition:all .2s; }
.ck-option:hover { border-color:#2A2520; }
.ck-option.selected { border-color:#BFA164; background:rgba(191,161,100,0.05); }
.ck-option-radio { width:20px; height:20px; min-width:20px; border-radius:50%; border:2px solid #3A3530; display:flex; align-items:center; justify-content:center; margin-top:2px; }
.ck-option.selected .ck-option-radio { border-color:#BFA164; }
.ck-radio-dot { width:10px; height:10px; border-radius:50%; background:#BFA164; }
.ck-option-title { color:var(--fm-h,#F5F0E8); font-size:14px; font-weight:600; margin-bottom:4px; }
.ck-option-desc { color:var(--fm-m,#A09888); font-size:12px; margin-bottom:4px; }
.ck-option-price { color:#BFA164; font-size:13px; font-weight:600; }
.ck-label { display:block; color:var(--fm-m,#A09888); font-size:12px; font-weight:500; margin-bottom:6px; }
.ck-input { width:100%; background:var(--fm-bg2,#0F0F0F); border:1px solid var(--fm-br,#1E1E1E); border-radius:8px; padding:10px 14px; color:var(--fm-h,#F5F0E8); font-size:14px; }
.ck-input:focus { border-color:#BFA164; outline:none; }
.ck-input::placeholder { color:#4A4540; }
.ck-phone-input { position:relative; }
.ck-phone-prefix { position:absolute; left:14px; top:50%; transform:translateY(-50%); color:var(--fm-s,#6B6356); font-size:14px; font-weight:500; z-index:2; }
.ck-insurance { padding:16px; background:var(--fm-bg2,#0F0F0F); border:1px solid var(--fm-br,#1E1E1E); border-radius:10px; }
.ck-paybill-info { padding:16px; background:var(--fm-bg2,#0F0F0F); border:1px solid var(--fm-br,#1E1E1E); border-radius:10px; }
.ck-paybill-grid { display:flex; flex-direction:column; gap:8px; margin-top:10px; }
.ck-paybill-grid > div { display:flex; justify-content:space-between; padding:8px 12px; background:var(--fm-bg1,#141414); border-radius:6px; }
.ck-paybill-grid .ck-label { margin:0; color:var(--fm-s,#6B6356); font-size:12px; }
.ck-paybill-grid .ck-value { color:var(--fm-h,#F5F0E8); font-size:14px; font-weight:700; }
.ck-review-section { padding:12px 0; border-bottom:1px solid var(--fm-br,#1E1E1E); }
.ck-review-label { color:var(--fm-s,#6B6356); font-size:11px; text-transform:uppercase; letter-spacing:0.5px; margin-bottom:4px; }
.ck-review-value { color:var(--fm-h,#F5F0E8); font-size:14px; }
.ck-review-sub { color:var(--fm-m,#A09888); font-size:12px; margin-top:2px; }
.ck-escrow-info { padding:14px; background:rgba(80,200,120,0.06); border:1px solid rgba(80,200,120,0.15); border-radius:10px; }
.ck-listing-card { display:flex; gap:14px; padding:14px; background:var(--fm-bg2,#0F0F0F); border-radius:10px; }
.ck-listing-img { width:80px; height:80px; border-radius:8px; object-fit:cover; flex-shrink:0; }
.ck-listing-placeholder { width:80px; height:80px; border-radius:8px; background:var(--fm-bg3,#1E1E1E); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.ck-listing-title { color:var(--fm-h,#F5F0E8); font-size:14px; font-weight:600; margin-bottom:4px; }
.ck-listing-meta { color:var(--fm-s,#6B6356); font-size:12px; margin-bottom:2px; }
.ck-seller-avatar { width:36px; height:36px; border-radius:50%; background:rgba(191,161,100,0.15); color:#BFA164; display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:700; flex-shrink:0; }
.ck-price-breakdown { margin-top:16px; }
.ck-price-row { display:flex; justify-content:space-between; padding:8px 0; color:var(--fm-m,#A09888); font-size:13px; border-bottom:1px solid var(--fm-br,#1E1E1E); }
.ck-price-total { display:flex; justify-content:space-between; padding:14px 0 0; color:var(--fm-h,#F5F0E8); font-size:18px; font-weight:700; }
.ck-trust-badges { display:flex; flex-wrap:wrap; gap:8px; }
.ck-badge { padding:6px 10px; background:rgba(80,200,120,0.06); border:1px solid rgba(80,200,120,0.12); border-radius:6px; color:#50C878; font-size:11px; font-weight:500; }
.ck-success-icon { width:64px; height:64px; border-radius:50%; background:rgba(80,200,120,0.15); display:flex; align-items:center; justify-content:center; margin:0 auto; }
.ck-success-icon i { font-size:32px; color:#50C878; }
.ck-mpesa-prompt { padding:20px; background:rgba(80,200,120,0.06); border:1px solid rgba(80,200,120,0.15); border-radius:12px; }
.ck-pulse { width:10px; height:10px; border-radius:50%; background:#50C878; animation:pulse 1.5s infinite; }
@keyframes pulse { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.5; transform:scale(1.3); } }

/* Vehicle grid */
.ck-vehicle-grid { display:grid; grid-template-columns:repeat(4, 1fr); gap:10px; }
.ck-vehicle { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; background:var(--fm-bg2,#0F0F0F); border:1px solid var(--fm-br,#1E1E1E); border-radius:10px; cursor:pointer; transition:all .2s; text-align:center; }
.ck-vehicle:hover:not(.unsuitable) { border-color:#2A2520; }
.ck-vehicle.selected { border-color:#BFA164; background:rgba(191,161,100,0.06); }
.ck-vehicle.unsuitable { opacity:0.4; cursor:not-allowed; }
.ck-vehicle-icon { font-size:24px; }
.ck-vehicle-name { font-size:12px; font-weight:600; color:var(--fm-h,#F5F0E8); }
.ck-vehicle-cap { font-size:10px; color:var(--fm-s,#6B6356); line-height:1.3; }
.ck-vehicle-fee { font-size:12px; font-weight:700; color:#BFA164; margin-top:2px; }
.ck-vehicle-info { display:flex; align-items:flex-start; gap:6px; font-size:11px; color:var(--fm-m,#A09888); background:rgba(191,161,100,0.06); border:1px solid rgba(191,161,100,0.15); border-radius:8px; padding:10px 12px; }

/* Location search dropdown */
.ck-loc-dropdown { position:absolute; top:100%; left:0; right:0; z-index:50; background:var(--fm-bg1,#141414); border:1px solid var(--fm-br,#2A2520); border-radius:8px; margin-top:4px; max-height:250px; overflow-y:auto; box-shadow:0 8px 30px rgba(0,0,0,0.5); }
.ck-loc-item { display:flex; align-items:flex-start; gap:8px; padding:10px 14px; cursor:pointer; transition:background .15s; }
.ck-loc-item:hover { background:rgba(191,161,100,0.08); }
.ck-loc-item:not(:last-child) { border-bottom:1px solid var(--fm-br,#1E1E1E); }
.ck-map-container { position:relative; border-radius:10px; overflow:hidden; border:1px solid var(--fm-br,#2A2520); }
.ck-interactive-map { width:100%; height:220px; background:var(--fm-bg2,#0F0F0F); z-index:1; }
.ck-map-hint { position:absolute; bottom:8px; left:50%; transform:translateX(-50%); background:rgba(10,10,10,0.85); border:1px solid var(--fm-br,#2A2520); border-radius:20px; padding:4px 14px; font-size:11px; color:var(--fm-m,#A09888); z-index:10; pointer-events:none; white-space:nowrap; }
.ck-gps-btn { background:var(--fm-bg3,#1E1E1E); border:1px solid var(--fm-br,#2A2520); color:#BFA164; width:44px; min-width:44px; border-radius:8px; display:flex; align-items:center; justify-content:center; font-size:18px; transition:all .2s; }
.ck-gps-btn:hover { background:#2A2520; border-color:#BFA164; color:#BFA164; }
.ck-gps-btn:disabled { opacity:0.5; }
.ck-loc-confirmed { display:flex; align-items:center; font-size:11px; color:#50C878; flex-wrap:wrap; }
.ck-distance-badge { display:flex; align-items:center; font-size:12px; color:var(--fm-m,#A09888); background:rgba(191,161,100,0.06); border:1px solid rgba(191,161,100,0.15); border-radius:8px; padding:8px 12px; }
.ck-mini-map { width:100%; height:120px; border-radius:8px; border:1px solid var(--fm-br,#2A2520); overflow:hidden; background:var(--fm-bg2,#0F0F0F); }

@media (max-width:768px) {
  .ck-sticky { position:relative; top:0; }
  .ck-step-line { width:30px; }
  .ck-vehicle-grid { grid-template-columns:repeat(2, 1fr); }
}
</style>
